import { render } from "./ResellerInformation.vue?vue&type=template&id=2dd3c3da&scoped=true"
import script from "./ResellerInformation.vue?vue&type=script&lang=js"
export * from "./ResellerInformation.vue?vue&type=script&lang=js"

import "./ResellerInformation.vue?vue&type=style&index=0&id=2dd3c3da&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd3c3da"]])

export default __exports__